module.exports = __webpack_public_path__ + "static/media/atendimento-2-mobile.d01b785b.png";